import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { FaMap } from 'react-icons/fa';

const WayfinderManagement = () => {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    setLoading(true);
    try {
      const response = await fetch('/auth/clients');
      const data = await response.json();

      // Filter clients with Wayfinder enabled
      const wayfinderClients = data.filter(
        client => client.featureAccess?.wayfinderEnabled
      );

      setClients(data);
    } catch (error) {
      console.error('Error fetching clients:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClientChange = (selectedOption) => {
    if (selectedOption) {
      // Navigate to the wayfinder page for the selected client
      navigate(`/wayfinder/${selectedOption.value}`);
    }
  };

  const clientOptions = clients.map(client => ({
    value: client._id,
    label: client.company_name,
  }));

  return (
    <div className="main-container">
      <div className="pd-ltr-20 xs-pd-20-10">
        <div className="min-height-200px dashboard-container">
          {/* Header Section */}
          <div className="page-header" style={{ marginBottom: '24px' }}>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div className="title">
                  <h4>
                    <FaMap style={{ marginRight: '8px' }} />
                    Wayfinder Management
                  </h4>
                </div>
              </div>
            </div>
          </div>

          {/* Client Selection Card */}
          <div className="card shadow-sm border-0 mb-4" style={{ overflow: 'unset' }}>
            <div className="card-header text-white" style={{ background: '#142127', padding: '20px' }}>
              <h5 className="card-title mb-0">
                <i className="fas fa-user-cog me-2"></i>
                Select Client
              </h5>
              <p className="card-text small mb-0">
                Choose a client to view and manage their Wayfinder configuration
              </p>
            </div>

            <div className="card-body p-4">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-3 text-muted">Loading clients...</p>
                </div>
              ) : clients.length === 0 ? (
                <div className="text-center py-5">
                  <FaMap size={60} className="text-muted mb-3" />
                  <h5 className="text-muted">No Clients with Wayfinder Enabled</h5>
                  <p className="text-muted">
                    Enable Wayfinder for clients in the Global Settings page
                  </p>
                  <Link to="/admin/global-settings" className="btn btn-primary mt-3">
                    <i className="fas fa-cog me-2"></i>
                    Go to Global Settings
                  </Link>
                </div>
              ) : (
                <div className="form-group mb-0">
                  <label className="form-label fw-semibold mb-3">
                    <i className="fas fa-building me-2"></i>
                    Client Selection
                  </label>
                  <Select
                    options={clientOptions}
                    onChange={handleClientChange}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Choose a client to manage..."
                    isClearable
                    isSearchable
                  />
                  <small className="form-text text-muted mt-2">
                    <i className="fas fa-info-circle me-1"></i>
                    Showing {clients.length} client{clients.length !== 1 ? 's' : ''} with Wayfinder enabled
                  </small>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .card-header {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 12px 12px 0 0 !important;
        }

        .card {
          border-radius: 12px;
          overflow: hidden;
        }

        .react-select-container {
          font-size: 1rem;
        }

        .dashboard-container {
          background: #f8f9fa;
          padding: 20px;
          border-radius: 8px;
        }
      `}</style>
    </div>
  );
};

export default WayfinderManagement;
